import { GET_INTERNSHIPS_STRUCTS } from "../../../../enums/Request/request.types";

export const getInternshipsStructsAction = (data) => {
    return {
        type: GET_INTERNSHIPS_STRUCTS,
        payload: data,
    };
};
